module.exports = "\n\n.table-contributor .mat-cell:nth-child(3), .table-contributor .mat-header-cell:nth-child(3) {\n  display: none;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/contributor/contributor-search-list/contributor-search-list.component.css
// module id = ./src/app/components/contributor/contributor-search-list/contributor-search-list.component.css
// module chunks = main